import {Component, inject, OnInit, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {Permissions} from "../../../../../enums/permissions";
import {Router} from "@angular/router";
import {SessionService} from "../../../../../services/session.service";
import {PendingUsersService} from "../../../../../services/pending-users.service";
import {TableSort} from "../../../../../interfaces/table/table-sort";

@Component({
  selector: 'user-profile',
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css',
  standalone: false
})
export class UserProfileComponent implements OnInit {
  currentUser: any = null;
  isProfileClicked: any = false;
  totalPendingItems: number = 0;

  protected readonly Permission = Permissions;
  private readonly router = inject(Router);
  private readonly sessionService = inject(SessionService);
  private readonly pendingUserService = inject(PendingUsersService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.sessionService.currentUser.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.currentUser = res.user;
      this.fetchPendingUsers();
    });
  }

  private fetchPendingUsers(): void {
    if (this.hasPermission(Permissions.ViewPendingUsers)) {
      const sortParams: TableSort = {columnId: '', direction: 'desc'};
      this.pendingUserService.getPendingUsers(1, 0, '', sortParams).then((users: any) => {
        this.totalPendingItems = users.Data.length !== 0 ? users.Data[0].total_pending_users : 0;
      });
    }
  }

  hasPermission(permission: string): any {
    if (!this.currentUser?.permission) return false;
    const permissions = this.currentUser.permission.split(',');
    return permissions.includes(permission);
  }

  isCurrentPageHref(url: string) {
    return window.location.pathname.includes(url);
  }

  logout() {
    this.sessionService.Logout();
  }

  toggleProfileMenu() {
    this.isProfileClicked = !this.isProfileClicked;
  }

  closeProfileMenu() {
    this.isProfileClicked = false;
  }

  routeToPendingUsers() {
    this.router.navigate(['pending-users'])
      .then(() => this.closeProfileMenu());
  }

  routeToInvitedUsers() {
    this.router.navigate(['invited-users'])
      .then(() => this.closeProfileMenu());
  }

  isPendingUsersIndicatorVisible(): boolean {
    const isPendingUsersEmpty = this.totalPendingItems == 0;
    const isPendingUsersPage = this.router.url.includes('pending-users');
    return !isPendingUsersEmpty && !isPendingUsersPage && this.hasPermission(Permissions.ViewPendingUsers);
  }
}
